<nb-card>
  <nb-card-header
    ><h4>
      {{ "dialogs.eventFeedDetails.title" | translate }}
    </h4></nb-card-header
  >
  <nb-card-body class="container">
    <div class="user">
      <img
        class="avatar"
        src="{{ getAvatarUrl(item.user_id) }}"
        nbPopover="User: {{ item.user_id }}"
        nbPopoverTrigger="hover"
      />
      <span
        ><b>User:</b> <br />
        {{ item.user_id }}</span
      >
    </div>

    <div class="event-info">
      <p>
        <strong>{{ "charts.labels.eventType" | translate }}: </strong>
        <span
          class="event-label"
          [innerHTML]="'charts.eventFeed.' + item.event_type | translate"
        ></span>
        <span> ({{ item.event_type }})</span>
      </p>

      <p>
        <strong>{{ "charts.labels.eventTime" | translate }}: </strong>
        <span class="event-label"
          >{{ item.ts_event | date : "medium" }} ({{
            item.ts_event | timeago
          }})</span
        >
      </p>

      <p>
        <strong>{{ "charts.labels.botName" | translate }}: </strong>
        <span class="event-label">
          <app-agent-identity-label
            [visualName]="item.bot_visual_name"
            [internalName]="item.bot_name"
            [fallback]="item.bot_id"
          ></app-agent-identity-label>
        </span>
      </p>

      <p *ngIf="item.location_url">
        <strong>{{ "charts.labels.locationUrl" | translate }}: </strong>
        <span class="event-label"
          ><a href="{{ item.location_url }}" target="_blank">{{
            item.location_url
          }}</a></span
        >
      </p>

      <p *ngIf="item.bloom">
        <strong>{{ "charts.labels.bloom" | translate }}: </strong>
        <span class="event-label"
          >{{ "charts.labels." + item.bloom | translate }}
        </span>
      </p>

      <p *ngIf="item.event_action">
        <strong>{{ "charts.labels.eventAction" | translate }}: </strong>
        <span class="event-label"
          >{{ "charts.labels." + item.event_action | translate }}
        </span>
      </p>

      <p *ngIf="item?.question_topic">
        <strong>{{ "charts.labels.questionTopic" | translate }}: </strong>
        <span class="event-label">{{ item?.question_topic }} </span>
      </p>

      <p *ngIf="item?.intent">
        <strong>{{ "charts.labels.intent" | translate }}: </strong>
        <span class="event-label"
          >{{ "charts.labels." + item?.intent | translate }}
        </span>
      </p>

      <p *ngIf="item?.canonical_text">
        <strong>{{ "charts.labels.canonicalText" | translate }}: </strong>
        <br />
        <span class="event-message">{{ item?.canonical_text }} </span>
      </p>

      <p *ngIf="item?.event_data?.user_message">
        <strong>{{ "charts.labels.userMessage" | translate }}: </strong>
        <br />
        <span class="event-message">{{ item?.event_data?.user_message }} </span>
      </p>

      <p *ngIf="item?.event_data?.ai_response">
        <strong>{{ "charts.labels.userMessage" | translate }}: </strong>
        <br />
        <span class="event-message">{{ item?.event_data?.ai_response }} </span>
      </p>

      <p *ngIf="item?.event_data?.problem_statement">
        <strong>{{ "charts.labels.problemStatement" | translate }}: </strong>
        <br />
        <span class="event-message"
          >{{ item?.event_data?.problem_statement }}
        </span>
      </p>

      <p *ngIf="item?.event_data?.user_answer">
        <strong>{{ "charts.labels.userAnswer" | translate }}: </strong>
        <br />
        <span class="event-message">{{ item?.event_data?.user_answer }} </span>
      </p>

      <p *ngIf="item?.answer_correct">
        <strong>{{ "charts.labels.answerCorrect" | translate }}: </strong>
        <span class="event-label"
          >{{ item?.answer_correct ? "✅" : "❌" }}
        </span>
      </p>

      <p *ngIf="item?.event_data?.judgment_logic">
        <strong>{{ "charts.labels.judgmentLogic" | translate }}: </strong>
        <br />
        <span class="event-message"
          >{{ item?.event_data?.judgment_logic }}
        </span>
      </p>

      <p *ngIf="item?.event_data?.correct_answer">
        <strong>{{ "charts.labels.answers" | translate }}: </strong>
        <br />
        <span>
          <ul>
            <li
              *ngFor="let answer of item?.event_data?.correct_answer"
              class="event-message"
            >
              {{ answer.text }}
              <span *ngIf="answer.is_correct">{{
                answer.is_correct ? "✅" : "❌"
              }}</span>
            </li>
          </ul>
        </span>
      </p>

      <p *ngIf="item?.event_data?.answer_quality">
        <strong>{{ "charts.labels.answerQuality" | translate }}: </strong>
        <span class="event-label">{{ item?.event_data?.answer_quality }} </span>
      </p>

      <p *ngIf="item?.event_data?.attempt">
        <strong>{{ "charts.labels.attempt" | translate }}: </strong>
        <span class="event-label">{{ item?.event_data?.attempt }} </span>
      </p>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button
      type="submit"
      nbButton
      status="primary"
      (click)="dialogRef.close(true)"
    >
      {{ "buttons.close" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
